import React from 'react';

export function removeInitialZero(number) {
  return number.charAt(0) === '0' ? number.charAt(1) : number;
}
